import React from 'react';
import { AppButton, Box, Inscription, Preloader, WalletIcon } from '@common-fe/common-fe';

import theme from '@/styles/theme';

import { CardStatusActionWrap } from '../ChangeStatusCardModal.styles';

const ACCOUNTS_ACCESS_TEXT = 'Accounts Access';
const ACCOUNTS_ACCESS_DESCRIPTION = 'Lock or unlock individual accounts. The account status will be reflected on all cards.';

interface CardAccountsAccessCardProps {
  loadingButton: boolean;
  onOpenManageAccountAccessModal: () => void;
}

const CardAccountsAccessCard: React.FC<CardAccountsAccessCardProps> = ({
  loadingButton,
  onOpenManageAccountAccessModal,
}) => (
  <CardStatusActionWrap
    width="100%"
    height="96px"
    padding={theme.spacings.l}
    background="canvas"
    round="container1Round"
    $withBorderShadow
    justify="between"
    style={{ maxWidth: '624px' }}
  >
    <Box direction="row" justify="between" align="center" gap="spacing12">
      <Box direction="row" align="center">
        <WalletIcon size="48px" color="iconAccent" />
        <Box justify="center" margin={{ left: 'm' }}>
          <Inscription color="textBody" weight="bold" lineHeight="20px" margin={{ bottom: 'xxxs' }}>
            {ACCOUNTS_ACCESS_TEXT}
          </Inscription>
          <Inscription color="textBody" lineHeight="20px">
            {ACCOUNTS_ACCESS_DESCRIPTION}
          </Inscription>
        </Box>
      </Box>
      <AppButton
        testId="card-accounts-access-card_button"
        buttonType="primary"
        width="180px"
        style={{ height: '40px', padding: `${theme.spacings.spacing10} ${theme.spacings.spacing12}` }}
        disabled={loadingButton}
        onClick={onOpenManageAccountAccessModal}
      >
        {loadingButton ? (
          <Box width="100%" align="center">
            <Preloader color="white" />
          </Box>
        ) : (
          'Lock/Unlock Accounts'
        )}
      </AppButton>
    </Box>
  </CardStatusActionWrap>
);

export default CardAccountsAccessCard;
